__turbopack_context__.v({
  "root": "complaint-scatter-module__dlxX0W__root",
  "tooltip": "complaint-scatter-module__dlxX0W__tooltip",
});
